import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { Flex } from '@atlaskit/primitives';
import { WindowUtils } from '@atlassian/mpac-utils';
import React, { useEffect, useRef } from 'react';
import { MULTI_STEP_DRAG_AND_DROP_ADD_NEW_RECORD } from '../../constants/testIds';
import AccordianBox from '../AccordianBox';
import { reorderArray } from './MultiStepDragAndDrop.utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MultiStepDragAndDrop = props => {
  const {
    label,
    fieldProps,
    addNewRecordLabel
  } = props;
  const {
    value,
    onChange
  } = fieldProps;
  const valueRef = useRef(value);

  // Keep ref updated with the latest value
  useEffect(() => {
    valueRef.current = value;
  }, [value]);
  useEffect(() => {
    return monitorForElements({
      onDrop(_ref) {
        let {
          location,
          source
        } = _ref;
        const destination = location.current.dropTargets[0];
        if (!destination) {
          // if dropped outside of any drop targets
          return;
        }
        const destIndex = value.findIndex(record => record.id === destination.data.id);
        const sourceIndex = value.findIndex(record => record.id === source.data.id);
        if (destIndex >= 0 && sourceIndex >= 0) {
          onChange(reorderArray(value, sourceIndex, destIndex));
        }
      }
    });
  }, [value, onChange]);
  const onDelete = index => {
    onChange([...value.slice(0, index), ...value.slice(index + 1)]);
  };
  const addNewRecord = () => {
    onChange([...value, {
      id: WindowUtils.randomUUID(),
      isAccordianBoxOpen: true
    }]);
  };
  const onFieldChange = (fieldName, id) => newValue => {
    const newRecords = valueRef.current.map(record => {
      if (record.id === id) {
        return _objectSpread(_objectSpread({}, record), {}, {
          [fieldName]: newValue
        });
      }
      return record;
    });
    onChange([...newRecords]);
  };
  const Content = props.content;
  const enableDelete = !fieldProps.isDisabled && addNewRecordLabel;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "space.200",
    direction: "column",
    children: [fieldProps.value.map((record, index) => /*#__PURE__*/_jsx(AccordianBox, {
      title: "".concat(label, " ").concat(index + 1),
      onDelete: enableDelete ? () => onDelete(index) : undefined,
      isOpen: record.isAccordianBoxOpen,
      id: record.id,
      enableDrag: true,
      children: /*#__PURE__*/_jsx(Content, {
        value: record,
        onFieldChange: onFieldChange,
        isDisabled: fieldProps.isDisabled
      })
    }, record.id)), addNewRecordLabel && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        testId: MULTI_STEP_DRAG_AND_DROP_ADD_NEW_RECORD,
        iconBefore: /*#__PURE__*/_jsx(EditorAddIcon, {
          label: "add-icon"
        }),
        onClick: addNewRecord,
        isDisabled: fieldProps.isDisabled,
        children: addNewRecordLabel
      })
    })]
  });
};
export default MultiStepDragAndDrop;